
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IEmployeeItem } from '../../../models/employees.model';
import { Table, TableColumnsType } from 'antd';
import config from '../../../lib/config';
import Pagination from '../../Pagination';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import { getCommonCodeLabel } from '../../../lib/store';

interface IProps {
  employees: IEmployeeItem[];
  groupNo?: string;
  keyword?: string;
  page: number;
  param: any;
  onSearch: (memberCode: string | null, page: number | null) => void;
  memberCode: string;
  employeeStatus?: string;
}

const StaffTable: FC<IProps> = ({
  employees,
  groupNo,
  keyword,
  page,
  param,
  onSearch,
  memberCode,
  employeeStatus,
}) => {
  const { t, i18n } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);

  const [data, setData] = useState<IEmployeeItem[]>([]);

  useEffect(() => {
    let _data: IEmployeeItem[] = _.cloneDeep(employees);
    if (currentCampus) {
      _data = _data.filter((item) => item.campusCode === currentCampus);
    }
    if (groupNo) {
      _data = _data.filter((item) => item.groupNo === groupNo);
    }
    if (keyword) {
      _data = _data.filter(
        (item) =>
          item.memberName.includes(keyword) || item.webId.includes(keyword),
      );
    }
    if (employeeStatus) {
      _data = _data.filter((item) => item.employeeStatus === employeeStatus);
    }

    setData(_data);
  }, [employees, currentCampus, groupNo, keyword, employeeStatus]);

  const columns: TableColumnsType<IEmployeeItem> = [
    {
      title: t('message.archive.column5'),
      dataIndex: 'memberName',
      key: 'memberName',
      render: (value, record) =>
        i18n.language === 'ko' ? value : record.memberEngName,
    },
    {
      title: t('auth.login.label1'),
      dataIndex: 'webId',
      key: 'webId',
    },
    {
      title: t('common.column.group'),
      dataIndex: 'groupName',
      key: 'groupName',
      render: (value, record) =>
        i18n.language === 'ko' ? value : record.groupNameEn,
    },
    {
      title: t('class.class.column39'),
      dataIndex: 'employeeStatus',
      key: 'employeeStatus',
      render: (value, record) =>
        record.employeeStatus === '01'
          ? getCommonCodeLabel('MB0015', record.employeeStatus, i18n.language)
          : `${getCommonCodeLabel('MB0015', record.employeeStatus, i18n.language)}(${record?.retireDate.replace(
              /(\d{4})(\d{2})(\d{2})/,
              '$1.$2.$3',
            )})`,
    },
  ];

  return (
    <div>
      <div className="comm-bx__between">
        <div className="comm-sch_result">
          {t('common.text.count')}: <b>{data?.length}</b>
          {t('common.text.unit')}
        </div>
        <div></div>
      </div>
      <div>
        <Table
          className='comm-table__area mt-0'
          columns={columns}
          dataSource={data}
          pagination={{
            current: page,
            pageSize: config.smallPageSize,
          }}
          onRow={(record) => {
            return {
              onClick: () => {
                onSearch(record.memberCode, page);
              },
            };
          }}
          rowClassName={(record: any) =>
            record.memberCode === memberCode ? 'chosen' : 'pointer'
          }
        />
      </div>
      <div className="comm-bx__between">
        <div className="common-paging right">
          <Pagination
            count={data?.length}
            page={page}
            param={param}
            path="/campus/staff"
            small
          />
        </div>
      </div>
    </div>
  );
};

export default StaffTable;
